import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import store from './store';
import './i18n';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

store()
  .then((s) => {
    root.render(<App store={s} tab="home" />);
  })
  .catch((err) => {
    console.error(err.message);
  });
